import { updateFloatingIconsPosition } from '../helpers/utils';
export default (() => {
    console.log('UNTUCKit : Module : Scroll : loaded');
    const getHeader = () => document.querySelector('header');
    const getFooter = () => document.querySelector('footer');
    const getToTop = () => document.querySelector('.js-top');
    let showTop = false;
    let offsetY = 0;
    const scrollActive = () => document.querySelector('.no-scroll') !== null;
    const elementDocumentTop = (element) => element.getBoundingClientRect().top + window.scrollY;
    const onWindowScroll = () => {
        const toTop = getToTop();
        if (!toTop) {
            return;
        }
        const footer = getFooter();
        const belowFold = window.innerHeight;
        const footerOffset = footer ? elementDocumentTop(footer) : 0;
        const toTopOffset = elementDocumentTop(toTop) + toTop.offsetHeight;
        if (showTop) {
            if (toTopOffset >= footerOffset || toTopOffset <= belowFold) {
                toTop.classList.remove('is-active');
                updateFloatingIconsPosition(toTop.offsetHeight * -1);
                showTop = false;
            }
        }
        else if (toTopOffset < footerOffset && toTopOffset > belowFold) {
            toTop.classList.add('is-active');
            updateFloatingIconsPosition(toTop.offsetHeight);
            showTop = true;
        }
    };
    const onFaqClick = (event) => {
        if (!(event.currentTarget instanceof HTMLAnchorElement)) {
            return;
        }
        event.preventDefault();
        const hashId = event.currentTarget.getAttribute('href')?.split('#')[1];
        if (hashId) {
            animate(hashId);
        }
    };
    const onToTopClick = (event) => {
        event.preventDefault();
        animate(0);
    };
    const bindUIActions = () => {
        window.addEventListener('scroll', onWindowScroll);
        document.querySelectorAll('.js-faq').forEach((link) => {
            link.addEventListener('click', onFaqClick);
        });
        getToTop()?.addEventListener('click', onToTopClick);
    };
    function animate(scrollTo) {
        const headerHeight = getHeader()?.offsetHeight ?? 0;
        let newScrollTop;
        if (typeof scrollTo === 'number') {
            newScrollTop = scrollTo;
        }
        else {
            const target = document.getElementById(scrollTo);
            if (!target) {
                return;
            }
            newScrollTop = elementDocumentTop(target);
        }
        window.scrollTo({
            top: newScrollTop - headerHeight,
            left: 0,
            behavior: 'smooth',
        });
    }
    function lock() {
        if (scrollActive()) {
            return;
        }
        offsetY = window.scrollY;
        document.body.style.top = `${-offsetY}px`;
        document.body.classList.add('no-scroll');
        document.documentElement.style.overflow = 'hidden';
    }
    function unlock() {
        if (scrollActive()) {
            document.body.style.top = '';
            document.body.classList.remove('no-scroll');
            document.documentElement.style.overflow = '';
            window.scrollTo(0, offsetY);
        }
    }
    const init = () => {
        console.log('UNTUCKit : Module : Scroll : init');
        bindUIActions();
    };
    return {
        animate,
        init,
        lock,
        unlock,
    };
})();
